import { pow } from '../internal';
export var easeInOutQuint = function (x) { return x < 0.5
    ? 16 * x * x * x * x * x
    : 1 - pow(-2 * x + 2, 5) / 2; };
